import { PricingModelItem, PurchaseStudentType } from "../../services/pricingModel/model";
import { useTranslation } from "react-i18next";
import Dialog from "components/ui/Dialog";
import PurchasePlan from "../PurchasePlan";
import styles from "./styles.module.scss";

export interface Props {
  onClose: () => void;
  onSuccess: (purchasedItem: PricingModelItem) => void;
  type: PurchaseStudentType;
  backOptionsText?: string;
}

export default function PurchasePlanModal(props: Props) {
  const { t } = useTranslation();

  return (
    <Dialog
      size="sm"
      open
      header={null}
      bodyPadding="none"
      title={t("Common.purchasePlan.dialogTitle")}
      className={styles.dialog}
      onClose={props.onClose}
    >
      <PurchasePlan
        className={styles.purchasePlan}
        type={props.type}
        onBack={props.onClose}
        onSuccess={props.onSuccess}
      />
    </Dialog>
  );
}
